import * as ng from 'angular';

import { ApiHelperService, SessionService } from '../../shared';

export class ProfileController {
   static $inject = ['userApi', 'session', 'toast', 'apiHelper', 'fileDownload', '$window'];

   constructor(private userApi, private session:SessionService, private toast, private apiHelper:ApiHelperService, private fileDownload, private $window:ng.IWindowService) {
      this.role = this.session.getUser().role;

      this.userProfile = {
         id: this.session.getUser().id,
         handle: this.session.getUser().handle,
         name: this.session.getUser().name,
         email: this.session.getUser().email
      };
      this.downloadsEnabled = this.role.includes("Admin") || this.role.includes("Manager"); // Currently SuperAdmin/OrgAdmin and BrandManager/CampaignManager/EventManager
   }

   /**
    * Open the App Store page for the iOS app
    */
   downloadIosApp() {
      this.$window.open("https://apps.apple.com/us/app/iconex-events/id1496835196");
   }

   emailRegex = /(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))/;
   role:string;
   userProfile:{id:number,handle:string,name:string,email:string};
   downloadsEnabled:boolean;

   save(form:ng.IFormController) {
      if (form.$invalid) {
         return;
      }

      // empty email will confuse servers validation
      if (this.userProfile.email === '') {
         delete this.userProfile.email;
      }

      this.userApi.update(this.userProfile).then(() => {
         this.session.refreshUser();
         form.$setPristine();

         this.toast.success()
            .message('Your account has been successfully updated')
            .send();
      });
   }
}

ng.module('e360').controller('ProfileController', ProfileController);
